<div class="outer-container">

    <lib-title-bar
        [crumbs]="[{ 'label': 'Funding' }, { 'label': 'Adjustments' }]">

        <lib-action-button label="New Adjustment" fontImage="far fa-plus-circle fa-bg" (click)="onClickCreateAdjustment()">
        </lib-action-button>

    </lib-title-bar>

    <app-adjustments-log-filters
        [filter]="filter"
        (filterChanged)="filterChanged.emit($event)"
        [merchants]="merchants"
        [merchantsLoading]="merchantsLoading">
    </app-adjustments-log-filters>

    <lib-table-base
        class="adjustments-table"
        [columnDefs]="columnDefs"
        [rowsData]="adjustments"
        [rowsDataLoading]="adjustmentsLoading"
        [rowsDataError]="adjustmentsError"
        rowsDataEmptyMessage="No Adjustments"
        rowsDataErrorMessage="Error Loading Adjustments"
        [rowsDataShowWhileLoading]="true"
        selectedRowProperty="token"
        [sorting]="sorting"
        (sortingChanged)="onSortingChanged($event)"
        [pager]="pager"
        (pageChanged)="pageChanged.emit($event)"
        (rowSelected)="onRowSelected($event)">

        <ng-template let-element="element" let-columnId="columnId">
            <app-adjustments-table-cell-content
                [columnId]="columnId"
                [element]="element">
            </app-adjustments-table-cell-content>
        </ng-template>
    </lib-table-base>

</div>
